module.exports = __webpack_public_path__ + "img/hair_back_female_straight_medium_mask.997c5b1e.png";